import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Col, Row, Card, Descriptions, message, Typography, Skeleton } from "antd";
import dayjs from "dayjs";

import { getTasksByCode } from "../../API/tasks";
import BackButton from "../Common/BackButton/BackButton";
import BreadCrumb from "../Common/BreadCrumb/BreadCrumb";
import PageTitle from "../Common/PageTitle/PageTitle";
import ChangeLog from "../Common/ChangeLog/ChangeLog";
import Assetia from '../Common/Assetia/Assetia';

const { Title, Text } = Typography;

const TasksDetail = () => {
  const { code } = useParams();
  const navigate = useNavigate();
  const [taskCode, setTaskCode] = useState(null);

  useEffect(() => {
    const fetchTasks = async () => {
      try {
        const data = await getTasksByCode(code);
        setTaskCode(data);
      } catch (error) {
        message.error("No se encontró la tarea.");
      }
    };

    fetchTasks();
  }, [code]);

  const breadCrumbUrl = [
    { label: "Tareas", url: "/tasks" },
    { label: taskCode ? `${taskCode.name}` : "Cargando..." },
  ];

  const goToBioFunctions = () => {
    navigate(-1);
  };

  return (
    <>
      <Row justify="space-between">
        <Col>
          <PageTitle title="Detalle de Tareas" icon="assets" />
        </Col>
        <Col>
          <ChangeLog data={taskCode} logs={taskCode?.logs || []} />
        </Col>
      </Row>

      <Row justify="start" align="middle" gutter={16} style={{ marginBottom: 20 }}>
        <Col style={{ display: "flex", alignItems: "center" }}>
          <BackButton onConfirm={goToBioFunctions} />
          <BreadCrumb location={breadCrumbUrl} activeKey={code} />
        </Col>
      </Row>

      {!taskCode ? (
        <>
          <Skeleton active paragraph={{ rows: 6 }} />
          <div style={{ height: 32 }} />
          <Row gutter={[16, 16]}>
            <Col xs={24} md={12}>
              <Skeleton active paragraph={{ rows: 6 }} />
            </Col>
            <Col xs={24} md={12}>
              <Skeleton active paragraph={{ rows: 6 }} />
            </Col>
          </Row>
        </>
      ) : (
        <>
          <Row gutter={[16, 16]} justify="center">
            {/* Card de Información General */}
            <Col xs={24} md={24}>
              <Card hoverable className="detail-card">
                <div className="card-content">
                  <div className="text-content">
                    <Title className="title-custom" level={4}>Tarea</Title>

                    <Descriptions bordered column={1} size="middle">
                      <Descriptions.Item label="Nombre">
                        <Text strong>{taskCode.name}</Text>
                      </Descriptions.Item>

                      <Descriptions.Item label="Descripción">
                        {taskCode.description || "No disponible"}
                      </Descriptions.Item>

                      <Descriptions.Item label="Estado">
                        {taskCode.status?.name || "No disponible"}
                      </Descriptions.Item>

                      <Descriptions.Item label="Responsable Área">
                        {taskCode.responsible_area?.name || "No asignada"}
                      </Descriptions.Item>

                      <Descriptions.Item label="Fecha Comprometida">
                        {taskCode.date_committed
                          ? dayjs(taskCode.date_committed).format("DD/MM/YYYY HH:mm")
                          : "No definida"}
                      </Descriptions.Item>

                      <Descriptions.Item label="Fecha Finalización">
                        {taskCode.date_finished
                          ? dayjs(taskCode.date_finished).format("DD/MM/YYYY HH:mm")
                          : "Pendiente"}
                      </Descriptions.Item>

                      <Descriptions.Item label="Comentarios">
                        {taskCode.comments?.length > 0 ? (
                          <div style={{ maxHeight: 200, overflowY: "auto" }}>
                            {taskCode.comments.map((c) => (
                              <div key={c.id} style={{ marginBottom: 12 }}>
                                <Text strong>
                                  {c.user?.first_name} {c.user?.last_name}
                                </Text>
                                <div>{c.comment}</div>
                              </div>
                            ))}
                          </div>
                        ) : (
                          "Sin comentarios"
                        )}
                      </Descriptions.Item>
                    </Descriptions>
                  </div>
                </div>
              </Card>
            </Col>
          </Row>

          <Row style={{ marginTop: 80 }}>
            <Assetia
              pageTitle="detalle de tareas"
              pageDescription="cargar tus tareas y gestionarlos de manera simple"
              view="tasks_detail"
            />
          </Row>
        </>
      )}
    </>
  );
};

export default TasksDetail;